import React, { useEffect, useMemo, useState } from "react";
import { Badge, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";

import AdminPageHeader from "components/admin/AdminPageHeader";
import EmptyState from "components/EmptyState";
import { dealsRepo } from "data/repositories/dealsRepo";
import { favoritesRepo } from "data/repositories/favoritesRepo";
import { provincesRepo } from "data/repositories/provincesRepo";

export default function AdminFavoritesOverview() {
  const [favorites, setFavorites] = useState({ provinceIds: [], dealIds: [] });

  useEffect(() => {
    setFavorites(favoritesRepo.get());
  }, []);

  const provinceMap = useMemo(() => {
    const map = new Map();
    provincesRepo.list().forEach((item) => map.set(item.id, item));
    return map;
  }, []);

  const dealMap = useMemo(() => {
    const map = new Map();
    dealsRepo.list().forEach((item) => map.set(item.id, item));
    return map;
  }, []);

  return (
    <>
      <AdminPageHeader title="Admin — Favori İstatistikleri" description="Favorites kullanıcıya özel türetilmiş state olduğu için read-only özet olarak tutulur." />
      <Container className="mt--6" fluid>
        {!favorites.provinceIds.length && !favorites.dealIds.length ? <EmptyState title="Favori verisi yok" description="Bu ekran türetilmiş favori durumunu read-only olarak gösterir." /> : null}
        <Row>
          <Col xl="6">
            <Card className="shadow mb-4">
              <CardHeader className="border-0"><h3 className="mb-0">Favori iller</h3></CardHeader>
              <CardBody>
                <div className="display-4 mb-3">{favorites.provinceIds.length}</div>
                {favorites.provinceIds.map((id) => (
                  <Badge key={id} color="info" pill className="mr-1 mb-1">{provinceMap.get(id)?.name || id}</Badge>
                ))}
              </CardBody>
            </Card>
          </Col>
          <Col xl="6">
            <Card className="shadow mb-4">
              <CardHeader className="border-0"><h3 className="mb-0">Favori fırsatlar</h3></CardHeader>
              <CardBody>
                <div className="display-4 mb-3">{favorites.dealIds.length}</div>
                {favorites.dealIds.map((id) => (
                  <Badge key={id} color="primary" pill className="mr-1 mb-1">{dealMap.get(id)?.title || id}</Badge>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}